import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixin from "./mixins";
import Util from "@js/utils";
import SpineLoader from "@js/load-spine";
import Spinner from "@/components/common/spinner";
import Dot from "@/components/common/reddot";
import assetsLoad from "@/components/common/assetsLoad";
import fitContent from "@js/content-autofit";
import screenDirection from "@js/screen-direction";
import toast from "@js/toast";
import sound from "@js/sounds";
import btnModal from "@/components/common/BtnModal";
import guidance from "@/components/common/Guidance";
import utils from "redis/lib/utils";

const version = (window.version = "v2.1.0");

Vue.use(toast, store);
Vue.use(sound, store);
Vue.component("btnModal", btnModal); // 全局按钮组件
Vue.component("guidance", guidance); // 全局教学组件
// 竖屏提示
if (Util.pageUserAgent !== "client") {
  screenDirection();
}
if (Util.pageUserAgent !== "app") {
  // 头部不缩进
  document.body.className = "full-screen";
}
document.addEventListener("contextmenu", function (e) {
  return e.preventDefault();
});

// 运行自适应内容宽高
function setFit(
  vertical = 0,
  horizontal = 0,
  target = ".fit",
  parent = document.querySelector(".fit-container")
) {
  // fitContent(vertical, horizontal, target, parent);
}

const LANG_HASH = (Vue.prototype.LANG_HASH = langHash);

Vue.config.productionTip = false;
Vue.mixin(mixin);
Vue.prototype.util = Util;
Vue.prototype.$Spinner = Spinner;
Vue.prototype.$Dot = Dot;
Vue.prototype.$loadSpine = new SpineLoader();
Vue.prototype.$setFit = fitContent;

Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();

router.beforeResolve((to, from, next) => {
  // 当路由进入
  // 资源加载, 接口初始化等
  assetsLoad(
    goNext,
    function () {
      document.querySelector("#app").className = "loaded";
      Vue.prototype.$dotFn = Util.debounce(function (dots) {
        // 重新绘制红点提示
        Dot.hideDot();
        dots.forEach((i) => {
          if (document.querySelector(i.class)) {
            Dot.showDot(
              document.querySelector(i.class),
              i.top,
              i.left,
              i.right,
              i.type
            );
          }
        });
      }, 100);
    },
    version
  );
  function goNext() {
    store.dispatch("userInfo/upDateFirst", false);
    if (false) {
      // 是否强制显示选择第一只怪兽界面
      if (
        !to.path.includes("firstpet") &&
        store.state.userInfo.info.default_monster_id !== 0
      ) {
        router.replace("/firstpet");
        return;
      }
    } else {
      if (
        !to.path.includes("firstpet") &&
        store.state.userInfo.info.default_monster_id == 0
      ) {
        router.replace("/firstpet");
        return;
      } else if (
        to.path.includes("firstpet") &&
        store.state.userInfo.info.default_monster_id != 0
      ) {
        router.replace("/");
        return;
      }
    }
    if (store.state.userInfo.hasLogin) {
      next();
    }
  }
});

router.afterEach((to, from) => {
  if (router.getMatchedComponents().filter((i) => i.setGuidance).length > 1) {
    console.error("单个主路由只能存在一个教学引导");
    return;
  }
  router.getMatchedComponents().forEach(async (i, index) => {
    let toComponent = i;
    if (index == 0) {
      setTimeout(function () {
        toComponent.disablePoint = false;
      }, 2000);
      let toFitTop = toComponent.fitInfo
          ? toComponent.fitInfo.top
            ? toComponent.fitInfo.top
            : Util.px2rem(window.innerHeight * 0.1)
          : Util.px2rem(window.innerHeight * 0.1), // 获取当前匹配路由页面对象
        toTarget = toComponent.fitInfo ? toComponent.fitInfo.target : null,
        toPacityrent = toComponent.fitInfo ? toComponent.fitInfo.parent : null;
      if (toTarget) {
        setTimeout(function () {
          let target = document.querySelector(toTarget);
          target.style.height = "100%";
          target.style.bottom = 0;
          setFit(toFitTop, 0, toTarget, document.querySelector(toPacityrent));
          window.addEventListener(
            "resize",
            Util.debounce(async function () {
              target.style.height = "100%";
              target.style.bottom = 0;

              setFit(
                toFitTop,
                0,
                toTarget,
                document.querySelector(toPacityrent)
              );
            }, 200)
          );
        }, 100);
      }
      store.dispatch("upDatePath", to.path);
    }
    // 教程设置
    let guidance = toComponent.setGuidance;
    if (
      guidance &&
      Object.prototype.toString.call(guidance).toLowerCase() ==
        "[object function]"
    ) {
      guidance(store, Util.sleep, cb);
      // 防止在翻页动画时调用 新手引导
      async function cb() {
        let page = document.querySelector(".page");
        await Util.sleep(100);
        if (
          index == 0 &&
          !page.className.includes("enter-active") &&
          !page.className.includes("leave-active")
        ) {
          await Util.sleep(100);
          Vue.prototype.$eventHub.$emit("pageAniEnd");
        } else {
          await Util.sleep(100);
          cb();
        }
      }
    } else {
      await Util.sleep(1000);
      Vue.prototype.$eventHub.$emit("pageAniEnd");
    }
  });
});
let winLoad = false;
router.beforeEach((to, from, next) => {
  let paths = store.state.path;
  let toIndex = paths.indexOf(to.path);
  let fromIndex = paths.indexOf(from.path);
  // 判断页面是前进还是后退
  if (fromIndex != -1) {
    if (toIndex != -1 && toIndex < fromIndex) {
      // 前进
      store.commit("upDateDirection", "forward");
    } else {
      // 后退
      store.commit("upDateDirection", "reverse");
    }
  } else {
    if (winLoad) {
      store.commit("upDateDirection", "reverse");
    } else {
      store.commit("upDateDirection", "forward");
    }
  }

  // 更具路径判断是否要调用任务列表
  // if (to.path == "/") {
  //   store.dispatch("taskInfo/upDateTaskList");
  // }
  winLoad = true;
  next();
});
window.addEventListener(
  "resize",
  Util.debounce(async () => {
    await Util.sleep(100);
    store.dispatch("upDatePageSize", {
      width: document.body.clientWidth,
      height: document.body.clientHeight,
    });
  }, 1000)
);
const vm = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 兼容微端
window.innerWidth = document.body.clientWidth;
